import { useMutation, useRedirect, useNotify } from 'react-admin';

const customEdit = ({ basePath, resourceText, updatedText }) => {
  const [mutate] = useMutation();
  const redirect = useRedirect();
  const notify = useNotify();
  const edit = async (values) => {
    const formattedValues = values;
    formattedValues.courseId = values.courseId.id;
    formattedValues.scormId = values.scorms.id;
    try {
      await mutate(
        {
          type: 'update',
          resource: 'units',
          payload: { id: values.id, data: formattedValues },
        },
        { returnPromise: true }
      );
      redirect('list', basePath);
      notify(`${resourceText} ${values.id} ${updatedText}`, 'success');
    } catch (error) {
      if (error.body.errors) {
        notify(error.body.errors, 'error');
        return error.body.errors;
      }
    }
  };
  return edit;
};

export default customEdit;
